// extracted by mini-css-extract-plugin
module.exports = {"Title":"KeyFact_Title__3ZlnU","Text":"KeyFact_Text__3CE1U","Link":"KeyFact_Link__3FXM0","Wrapper":"KeyFact_Wrapper__MMD56","isDark":"KeyFact_isDark__23jy9"};